/**
 * Configuration for stadium lights component.
 * IMPORTANT: These values must match the original EXACTLY to preserve visual appearance.
 */

export const stadiumLightsConfig = {
  image: {
    url: "https://a.bracky.app/assets/landing/backgrounds/stadium-lights-889.webp",
    size: "cover",
    position: "center",
  },
  mask: {
    radialGradient:
      "radial-gradient(circle, white 20%, rgba(255,255,255,0.9) 35%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0.4) 70%, rgba(255,255,255,0.1) 85%, transparent 100%)",
  },
  blur: {
    base: 2,
    flash: 4,
    suffix: ".62px",
    hueRotate: 355, // degrees
    saturate: 1.2,
  },
  animation: {
    brightness: {
      values: [1.02, 0.98, 1.03],
      duration: 1,
      ease: "easeInOut",
    },
    opacity: {
      transition: "opacity 1s ease-out",
    },
  },
  // These class names MUST be static strings for Tailwind to work
  className: {
    left: "fixed top-0 -left-20 w-[280px] sm:w-[375px] md:w-[450px] lg:w-[525px] aspect-square z-1 pointer-events-none mix-blend-screen",
    right:
      "fixed top-0 -right-20 w-[280px] sm:w-[375px] md:w-[450px] lg:w-[525px] aspect-square z-1 pointer-events-none mix-blend-screen",
  },
}

/**
 * Get scale value based on window width.
 * IMPORTANT: These breakpoints and values must match the original EXACTLY.
 */
export function getScale(width: number): number {
  if (width >= 2000) return 2.5
  if (width >= 1280) return 2.2
  if (width >= 768) return 1.97
  if (width >= 640) return 1.97
  return 1.421
}

/**
 * Get base blur value based on window width.
 * Note: In original, all breakpoints return 2, but keeping structure for clarity.
 */
export function getBaseBlurPx(width: number): number {
  if (width >= 1280) return 2
  if (width >= 768) return 2
  if (width >= 640) return 2
  return 2
}
